/* eslint-disable max-lines */
import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import { useEffect, useState } from 'react';
import Typography from 'aquilla/core/atoms/Typography/Typography';
import AquillaButton from 'aquilla/core/molecules/Button';
import Image from '@base/Image';
import useWindowSize from '@hooks/useWindowSize';
import MUIDialog from '@material-ui/core/Dialog';
import YouTube from '@cont/FreeLesson/externalyoutube';
import { useRouter } from 'next/router';
import { businessPlatform } from '@utils/constants';
import {
  OFFLINE_CHECKOUT_STARTED,
  OFFLINE_CENTRE_KNOW_MORE_CLICKED,
  OFFLINE_GOAL_UID,
  OFFLINE_VIDEO_TOUR_PLAYED,
  KNOW_MORE_FLOW_TYPE_WEB_SUBSCRIPTION,
  OFFLINE_VIDEO_TOUR_PLAYED_TOUR_SOURCE_SUBSCRIPTION,
  OFFLINE_CHECKOUT_FLOW_TYPE_CITY
} from '@cont/OfflineCentres/constants';
import { segment } from '@actions/analytics';
import {
  subscriptionSubTypes,
  subscriptionSubTypesObj,
  subscriptionTypesObj,
  subscriptionTypes
} from '@constants/index';
import useGoalSpecificCities from '@api/hooks/offlineCentres/useGoalSpecificCities';
import { getPathName } from '@cont/CitySpecificOfflineCentres/utils';
import useCentreInfo from '@api/hooks/citySpecificOfflineCentres/useCentreInfo';
import { CHOOSE_CENTRE_ROUTE_MAPPING } from '@cont/NewSubscription/NewSubscriptionBenefits/utils';
import pushRoute from '@utils/pushRoute';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { useToggleable } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const SubHeading = styled(Typography)`
  font-weight: 400 !important ;
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_6B};
`;
const StyP2 = styled(Typography)`
  margin-left: ${Spacings.SPACING_2B};
`;

const IconButton = styled(AquillaButton)<{ $isSecondary: boolean }>`
  border: 1px solid var(--color-divider);
  font-size: ${Fonts.H5};
  color: ${({ $isSecondary }) =>
    $isSecondary ? 'var(--color-i-green);' : 'var(--color-text-tertiary)'};
  ${mediaQuery.uptoMobile} {
    padding: 1px 6px;
    height: ${Spacings.SPACING_12B};
  }
`;

const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${Spacings.SPACING_6B};
`;
const RightUpperDiv = styled.div`
  display: flex;
  margin-bottom: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoTablet} {
    flex-direction: column;
  }
`;

const CentreImagesDiv = styled.div`
  display: flex;
  width: 354px;
  height: 172px;
  flex-wrap: wrap;
`;

const FeatureDiv = styled.div`
  display: flex;
  margin-bottom: ${Spacings.SPACING_3B};
`;
const LeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  ${mediaQuery.uptoTablet} {
    /* margin-right: ${Spacings.SPACING_4B}; */
  }
`;
const RightDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
const WrapperDiv = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
  }
`;

const CentreBatchInfoDiv = styled.div`
  display: flex;
`;

const InfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${Spacings.SPACING_4B};
`;
const CentreImage = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyImage = styled(Image)`
  border-radius: ${Spacings.SPACING_1B};
`;

const CentreImageWrapper = styled.div<{
  $haveMarginRight: boolean;
  $haveMarginBottom: boolean;
}>`
  margin-right: ${({ $haveMarginRight }) => {
    return $haveMarginRight ? `${Spacings.SPACING_4B}!important;` : '0px';
  }};
  margin-bottom: ${({ $haveMarginBottom }) => {
    return $haveMarginBottom ? `${Spacings.SPACING_4B}!important;` : '0px';
  }};
  /* margin-bottom: ${Spacings.SPACING_4B} !important; */
  border-radius: ${Spacings.SPACING_1B};
  width: 168px;
  height: 78px;
  display: flex;
  flex-shrink: 0;
  ${mediaQuery.uptoMobile} {
    margin-right: ${Spacings.SPACING_4B};
    height: 138px !important;
    width: 280px !important;
  }
`;

const VideoCardContainer = styled.div`
  position: relative;
  /* overflow: hidden; */
  margin-right: ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  height: 178px;
  ${mediaQuery.uptoTablet} {
    margin-bottom: ${Spacings.SPACING_4B};
    margin-right: ${Spacings.SPACING_4B} !important;
    width: 354px;
  }
  ${mediaQuery.uptoMobile} {
    height: 138px;
  }
`;

const StyledDialog = styled(MUIDialog)`
  &.MuiDialog-root .MuiDialog-container .MuiPaper-root {
    position: absolute;
    background: var(--color-text-primary);
    height: 80%;
    width: 88%;
    max-width: 88%;
    @media only screen and (max-width: 540px) {
      margin: 16px auto;
      height: 30%;
    }
  }
`;
const PlayBtn = styled.img`
  position: absolute;
  bottom: ${Spacings.SPACING_4B};
  left: ${Spacings.SPACING_4B};
  cursor: pointer;
`;

const StyledImg = styled(Image)`
  border-radius: ${Spacings.SPACING_1B};
`;

const StyP3 = styled(Typography)`
  font-weight: ${Fonts.SEMIBOLD};
`;

const ButtonContainer = styled.div`
  display: flex;

  ${mediaQuery.uptoTablet} {
    /* flex-direction: column; */
    align-items: center;
    margin-top: ${Spacings.SPACING_6B};
    & > :nth-child(even) {
      margin-right: 0px !important;
      width: 140px;
    }
    & > :nth-child(odd) {
      margin-right: 16px !important;
      width: 140px;
    }
  }

  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    align-items: center;
    margin-top: ${Spacings.SPACING_6B};
    & > :nth-child(even) {
      margin-top: ${Spacings.SPACING_6B};
      margin-right: 0px !important;
      width: 100% !important;
    }
    & > :nth-child(odd) {
      margin-right: 0px !important;
      width: 100% !important;
    }
  }

  & > :nth-child(odd) {
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const HorizontalScroll = styled.div`
  display: flex;
  overflow-x: scroll;
  width: 100%;
  height: 138px;
  margin-bottom: ${Spacings.SPACING_6B};
  overflow-y: hidden;
`;

const opts = {
  height: '100%',
  width: '100%',
  playerVars: {
    autoplay: 1,
    showinfo: 0,
    rel: 0
  }
};
const VIDEO_URL = 'Vz3F0SgLY3Q';
const THUMBNAIL_URL =
  'https://unacademy-prod.s3.ap-southeast-1.amazonaws.com/web-cms/offline_offerings_thumbnail_d84b52fd44.png';

const VideoCard = ({ data: { videoUrl, thumbnailUrl } }) => {
  const { isMobile, isTablet } = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const openPlayer = () => {
    setIsOpen(true);
    segment.track(OFFLINE_VIDEO_TOUR_PLAYED, {
      goal_uid: OFFLINE_GOAL_UID,
      tour_source: OFFLINE_VIDEO_TOUR_PLAYED_TOUR_SOURCE_SUBSCRIPTION
    });
  };

  const closePlayer = () => {
    setIsOpen(false);
  };

  let thumbnailWidth = 260;
  if (isMobile) thumbnailWidth = 280;
  else if (isTablet) thumbnailWidth = 352;
  return (
    <VideoCardContainer>
      <StyledImg
        src={thumbnailUrl}
        width={thumbnailWidth}
        height={isMobile ? '136' : '172'}
        alt="thumbnail"
        unoptimized
        layout={isMobile ? 'fixed' : 'intrinsic'}
      />

      <PlayBtn
        src={
          isMobile
            ? '/static/images/subscriptionFeatures/playVideoBtn.png'
            : '/static/images/subscriptionFeatures/playVideoBtn.png'
        }
        width={isMobile ? '138' : '146'}
        height={isMobile ? '34' : '40'}
        alt="play"
        onClick={openPlayer}
      />
      <StyledDialog
        open={isOpen}
        // @ts-ignore
        // TransitionComponent={Transition}
        onClose={closePlayer}
      >
        <YouTube
          opts={opts}
          videoId={videoUrl}
          onEnd={closePlayer}
          useWrapper={false}
        />
      </StyledDialog>
    </VideoCardContainer>
  );
};

const OfflineCentres = ({
  subscriptionFeatures,
  setSelectedPriceMode,
  selectedPriceMode
}) => {
  const router = useRouter();
  const { isMobile } = useWindowSize();
  const { goalUID } = router.query;
  const [isLoading, setIsLoading] = useState(false);
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { defaultCentreUid, activeCities } = useGoalSpecificCities(goalUID);
  const { centreInfo } = useCentreInfo(goalUID, defaultCentreUid);
  const { centreDeepLinkUrl = '' } = centreInfo ?? {};

  const { openElement: openLoginDrawer } = useToggleable(LOGIN_DRAWER);

  const fallbackRoute = defaultCentreUid
    ? `/goal/-/${goalUID}/centre/-/${defaultCentreUid}`
    : '';
  const defaultCentreUrl = getPathName(centreDeepLinkUrl, fallbackRoute);

  const {
    hasOfflineCentres,
    offlineCentreHeading,
    offlineCentreDesc,
    offlineCitiesInfo,
    offlineBatchesInfo,
    offlineCentreImages,
    features = [],
    offlineCentreVideoURL,
    offlineCentreVideoThumbnail
  } = subscriptionFeatures;
  const offlineFeature = features.filter((feature) => feature.isOffline);
  const offlineCentreThumbnail = offlineCentreVideoThumbnail[0]?.url;
  const renderImages = () => {
    const imgsArray = offlineCentreImages.map((img, index) => {
      const imgURL = img.url[0]?.url;
      return (
        <CentreImageWrapper
          key={imgURL}
          $haveMarginRight={index === 0 || index === 2}
          $haveMarginBottom={index === 0 || index === 1}
        >
          <StyImage
            src={imgURL}
            width={isMobile ? '280px' : '168px'}
            height={isMobile ? '138px' : '78px'}
            alt="centre-image"
            key={imgURL}
          />
        </CentreImageWrapper>
      );
    });
    return imgsArray;
  };
  const subType = subscriptionSubTypesObj[subscriptionSubTypes.OFFLINE];
  const type = subscriptionTypesObj[subscriptionTypes.CENTRE];

  const selectCityHandler = () => {
    setIsLoading(true);
    segment.track(OFFLINE_CHECKOUT_STARTED, {
      goal_uid: OFFLINE_GOAL_UID,
      subscription_sub_type: subType,
      // Adding new prop here for upgrade flow
      subscription_type: type,
      business_platform: businessPlatform.UA_OFFLINE,
      batch_group_type: subType,
      checkout_flow_type: OFFLINE_CHECKOUT_FLOW_TYPE_CITY
    });
    const routeTo =
      (defaultCentreUrl
        ? `${defaultCentreUrl}?redirection_enabled=true&source=subscriptionWeb`
        : CHOOSE_CENTRE_ROUTE_MAPPING[goalUID]) || '/offline/centres/subscribe';
    pushRoute(routeTo);
  };

  const handleChooseCityClick = () => {
    if (isLoggedIn) {
      selectCityHandler();
    } else {
      setSelectedPriceMode('offline');
      openLoginDrawer();
    }
  };

  useEffect(() => {
    if (isLoggedIn && selectedPriceMode && selectedPriceMode === 'offline')
      selectCityHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  if (!hasOfflineCentres) return null;
  if (isMobile) {
    return (
      <WrapperDiv>
        <HorizontalScroll>
          <VideoCard
            data={{
              videoUrl: offlineCentreVideoURL || VIDEO_URL,
              thumbnailUrl: offlineCentreThumbnail || THUMBNAIL_URL
            }}
          />
          {renderImages()}
        </HorizontalScroll>
        <HeaderSection>
          <Typography variant="h3">{offlineCentreHeading}</Typography>
          <SubHeading variant="h5">{offlineCentreDesc}</SubHeading>
        </HeaderSection>
        <ContentDiv>
          {offlineFeature &&
            offlineFeature.map((feature, index) => {
              return (
                <FeatureDiv key={feature.id}>
                  <Image
                    src="/subscriptionFeatures/offlineFeatureTick.svg"
                    width={Spacings.SPACING_5B}
                    height={Spacings.SPACING_5B}
                    alt="checked"
                  />
                  <StyP2 variant="p2">{feature.name}</StyP2>
                </FeatureDiv>
              );
            })}
        </ContentDiv>
        <CentreBatchInfoDiv>
          <CentreImage>
            <Image
              src="/subscriptionFeatures/cityCentreInfo.svg"
              width={Spacings.SPACING_10B}
              height={Spacings.SPACING_10B}
              alt="centre"
            />
          </CentreImage>
          <InfoDiv>
            <Typography variant="h7">{offlineBatchesInfo}</Typography>
            <Typography variant="p2">{offlineCitiesInfo}</Typography>
          </InfoDiv>
        </CentreBatchInfoDiv>
        <ButtonContainer>
          <IconButton
            // @ts-ignore
            label="Select a city"
            onClick={handleChooseCityClick}
            size="large"
            variant="brand"
            $isSecondary={false}
            isLoading={isLoading}
          />
        </ButtonContainer>
      </WrapperDiv>
    );
  }

  return (
    <WrapperDiv>
      <LeftDiv>
        <HeaderSection>
          <StyP3 variant="p3">{offlineCentreHeading}</StyP3>
          <SubHeading variant="h5">{offlineCentreDesc}</SubHeading>
        </HeaderSection>
        <ContentDiv>
          {offlineFeature &&
            offlineFeature.map((feature, index) => {
              return (
                <FeatureDiv key={feature.id}>
                  <Image
                    src="/subscriptionFeatures/offlineFeatureTick.svg"
                    width={Spacings.SPACING_5B}
                    height={Spacings.SPACING_5B}
                    alt="checked"
                  />
                  <StyP2 variant="p2">{feature.name}</StyP2>
                </FeatureDiv>
              );
            })}
        </ContentDiv>
        <ButtonContainer>
          <IconButton
            // @ts-ignore
            label={
              activeCities?.length === 1 ? 'Checkout Centre' : 'Choose centre'
            }
            onClick={handleChooseCityClick}
            size="large"
            variant="brand"
            $isSecondary={false}
            isLoading={isLoading}
          />
        </ButtonContainer>
      </LeftDiv>
      <RightDiv>
        <RightUpperDiv>
          <VideoCard
            data={{
              videoUrl: offlineCentreVideoURL || VIDEO_URL,
              thumbnailUrl: offlineCentreThumbnail || THUMBNAIL_URL
            }}
          />
          <CentreImagesDiv>{renderImages()}</CentreImagesDiv>
        </RightUpperDiv>
        <CentreBatchInfoDiv>
          <CentreImage>
            <Image
              src="/subscriptionFeatures/cityCentreInfo.svg"
              width={Spacings.SPACING_10B}
              height={Spacings.SPACING_10B}
              alt="centre"
            />
          </CentreImage>
          <InfoDiv>
            <StyP3 variant="p3">{offlineBatchesInfo}</StyP3>
            <Typography variant="p3">{offlineCitiesInfo}</Typography>
          </InfoDiv>
        </CentreBatchInfoDiv>
      </RightDiv>
    </WrapperDiv>
  );
};

export default OfflineCentres;
